const isLocal =
  typeof window !== 'undefined' &&
  (/^localhost$|^127\.0\.0\.1$/i.test(window.location.hostname) || window.location.protocol === 'file:')

export const API_BASE =
  import.meta.env.VITE_API_BASE ||
  (isLocal ? 'http://localhost:8787' : 'https://clyr-api.nigroan67.workers.dev')

export const VOICE_API_BASE =
  import.meta.env.VITE_VOICE_API_BASE ||
  API_BASE

export const MAIN_SITE_URL =
  import.meta.env.VITE_MAIN_SITE_URL ||
  (isLocal ? 'http://localhost:8788' : 'https://clyrzones.com')

export const SESSION_KEY = 'clyr_session'
export const USER_KEY = 'clyr_user'
